import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import RoleActions from "../../Role/RoleActions";

type RolesListItemActionsDropdownCellProps = CellComponentProps;

const RolesListItemActionsDropdownCell = ({
  role,
  readOnly,
}: RolesListItemActionsDropdownCellProps) => {
  return (
    <RoleActions
      role={role}
      analyticsPage={ANALYTICS.analyticsPage}
      refetchQueries={["GetRoles"]}
      readOnly={readOnly}
    />
  );
};

export default RolesListItemActionsDropdownCell;
